import { useEffect } from 'react';

/**
 * Freezes scroll on a container element without removing the scrollbar (avoids layout shift).
 *
 * @param {string} containerId - The DOM element ID to freeze scrolling on.
 * @param {boolean} shouldFreeze - Whether to freeze scroll (typically your `open` state).
 */
export function useFreezeScroll(containerId, shouldFreeze) {
   useEffect(() => {
      const container = containerId ? document.getElementById(containerId) : null;
      if (!container) return;

      const preventScroll = e => {
         e.preventDefault();
         e.stopPropagation();
      };

      if (shouldFreeze) {
         container.addEventListener('wheel', preventScroll, { passive: false });
         container.addEventListener('touchmove', preventScroll, { passive: false });
      } else {
         container.style.overflowY = '';
         container.removeEventListener('wheel', preventScroll);
         container.removeEventListener('touchmove', preventScroll);
      }

      return () => {
         container?.removeEventListener('wheel', preventScroll);
         container?.removeEventListener('touchmove', preventScroll);
         container.style.overflowY = '';
      };
   }, [containerId, shouldFreeze]);
}
